module.exports = __webpack_public_path__ + "media/images/hero-3-5e92b4b6.jpg";